import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import ElbowCurve from "./ElbowCurve";
import Link from "antd/es/typography/Link";
import GraphModal from "./GraphModel";

const AdminLeave = ({ setIsCreateClusterDisabled, setPageSize }) => {
  const [epochs, setEpochs] = useState(100); // Default to 100 epochs
  const [clusters, setClusters] = useState(""); // Make clusters required
  const [algorithm, setAlgorithm] = useState("KWH"); // Make algorithm required
  const [model, setModel] = useState("Segmentation.py"); // Make model required
  const [showElbowCurve, setShowElbowCurve] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [dis, setDis] = useState(false);

  // useEffect(() => {
  //   // Check if all the fields are filled to enable the form
  //   if (clusters && algorithm && model) {
  //     setIsFormValid(true);
  //   } else {
  //     setIsFormValid(false);
  //   }
  //   // Update the disabled state of the Create Cluster button
  // }, [clusters, algorithm, model, setIsCreateClusterDisabled]);

  const handleAlgorithmChange = (algo) => {
    setAlgorithm(algo);
  };

  const handleModelChange = (mode) => {
    setModel(mode);
  };

  const handleClustersChange = (e) => {
    setClusters(e.target.value);
  };

  const handleCreateCluster = (e) => {
    setIsCreateClusterDisabled(!(clusters && algorithm && model));

    // e.preventDefault();
    if (clusters && algorithm && model) {
      setShowElbowCurve(true);
    } else {
      setShowElbowCurve(false);
    }
  };

  const handleCloseModal = () => {
    setShowElbowCurve(false);
  };

  return (
    <>
      <ToastContainer />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="progress-steps">
                  <div className="progress-item">
                    <div className="progress-circle bg-success"></div>
                    <p className="progress-label">Data Collection</p>
                  </div>
                  <div className="progress-item">
                    <div className="progress-circle bg-success"></div>
                    <p className="progress-label">Data Processing</p>
                  </div>
                  <div className="progress-item">
                    <div className="progress-circle bg-success"></div>
                    <p className="progress-label">Segmentation</p>
                  </div>
                  <div className="progress-item">
                    <div className="progress-circle bg-secondary"></div>
                    <p className="progress-label">Results</p>
                  </div>
                </div>
                {/* Progress Bar */}
                <div className="progress">
                  <div
                    className="progress-bar bg-success"
                    style={{ width: "69.4%" }}
                    role="progressbar"
                    aria-valuenow={70}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            </div>
          </div>
          <h2>Step-1 Run Initial Segmentation</h2>

          <div className="col-xl-12 mx-auto">
            <form
              onSubmit={handleCreateCluster}
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div className="row">
                <div className="col-md-4">
                  <div className="card">
                    <div className="btn-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {model || "Select Model"}
                      </button>
                      <ul className="dropdown-menu dropdown-menu-primary">
                        <li>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleModelChange("Segmentation.py")}
                          >
                            Segmentation.py
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card">
                    <div className="btn-group">
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {algorithm || "Select Parameters"}
                      </button>
                      <ul className="dropdown-menu dropdown-menu-primary">
                        <li>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleAlgorithmChange("KWH")}
                          >
                            KWH
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleAlgorithmChange("KVAH")}
                          >
                            KVAH
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card-body">
                    <input
                      type="number"
                      value={clusters || 10}
                      onChange={handleClustersChange}
                      // defaultValue={10}
                      className="form-control"
                      placeholder="Enter number of clusters"
                      min="1"
                      required
                      style={{ height: "30px" }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div
                  className="col-md-12 text-center"
                  style={{ margin: "12px" }}
                >
                  {/* <button
                    type="submit"
                    className="btn btn-primary"
                    // disabled={!isFormValid} // Disable button if form is invalid
                  >
                    Create Cluster
                  </button> */}
                  <button className="btn btn-primary">
                    <Link
                      // className="dropdown-item"
                      to="#"
                      data-bs-toggle="modal"
                      // data-bs-backdrop="static"
                      aria-labelledby="delete"
                      aria-hidden="true"
                      // data-bs-target="#edit_leave"
                      data-bs-target="#delete"
                      style={{ color: "white" }}
                    >
                      Create Cluster
                    </Link>
                  </button>
                </div>
              </div>

              {showElbowCurve && <ElbowCurve />}
            </form>
          </div>
        </div>
      </div>
      <GraphModal />
    </>
  );
};

export default AdminLeave;
